import { render } from "./S198137.vue?vue&type=template&id=40f7649f"
const script = {}
script.render = render

export default script